import {
  FETCH_RAW_STOCKS_REQUEST,
  FETCH_RAW_STOCKS_SUCCESS,
  FETCH_RAW_STOCKS_FAILURE,
  CREATE_RAW_STOCK,
  UPDATE_RAW_STOCK,
  DELETE_RAW_STOCK,
} from '../../types/rawStock/rawStockTypes';

const initialState = {
  rawStocks: [],
  loading: false,
  error: null,
  appending: false,
};

const rawStockReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RAW_STOCKS_REQUEST:
      return { 
        ...state, 
        loading: action.append ? state.loading : true,
        appending: Boolean(action.append),
        error: null
      };

    case FETCH_RAW_STOCKS_SUCCESS:
      if (action.append) {
        const existingIds = new Set(state.rawStocks.map(item => item.id));
        const merged = [
          ...state.rawStocks,
          ...action.payload.filter(item => !existingIds.has(item.id)),
        ];
        return {
          ...state,
          loading: false,
          appending: false,
          rawStocks: merged,
        };
      }
      return { ...state, loading: false, appending: false, rawStocks: action.payload };

    case FETCH_RAW_STOCKS_FAILURE:
      return { ...state, loading: false, appending: false, error: action.payload };

    case CREATE_RAW_STOCK:
      return {
        ...state,
        rawStocks: [...state.rawStocks, action.payload],
      };

    case DELETE_RAW_STOCK:
      return {
        ...state,
        rawStocks: state.rawStocks.filter((d) => d.id !== action.payload),
      };

    case UPDATE_RAW_STOCK:
      return {
        ...state,
        rawStocks: state.rawStocks.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default rawStockReducer; 